import { CRRender } from '@/components/crRender'
import RequestFlow from '@/components/RequestFlow'
import { FLOW_STEPS, STATUS_MAP, STATUS_MAP_TEXT, StatusColorMap } from '@/data/status'
import { translate } from '@/utils/langUtils'
import { FormateDate } from '@/utils/varsManipulations'
import { Icon } from '@iconify/react/dist/iconify.js'

const RequestInfo = ({ requestDetails, PrevRef }: { requestDetails: any, PrevRef: any }) => {


    return (
        <>

            <div className="row">
                <div className=" col-7 ">
                    <div className="rd-request-number">
                        {translate("Request Number")}: {requestDetails?.id}
                    </div>
                    <div className="rd-request-date">
                        {FormateDate(requestDetails?.orderDate)}
                    </div>
                </div>
                <div className="col-5 text-center" onClick={() => PrevRef?.current?.click()}>
                    <div className="rd-prev-date">
                        {translate("prev-offer")}
                    </div>
                </div>
            </div>

            <div className="rd-stepper-card">
                <RequestFlow statusesLog={requestDetails?.statusesLog || []} steps={FLOW_STEPS.filter((step) => requestDetails?.orderStatusId != STATUS_MAP.RequestClosed ? step.key != STATUS_MAP.RequestClosed : true)} currentStep={requestDetails?.orderStatusId} />
            </div>

            <div className="rd-info-bar">
                <div className="rd-info-item">
                    <span className="rd-info-label">{translate("Request Status")}</span>
                    <span className={`status-badge ${StatusColorMap[requestDetails?.orderStatusId]}`}>
                        {translate(STATUS_MAP_TEXT[requestDetails?.orderStatusId])?.toUpperCase()}
                    </span>
                </div>

                <CRRender isRender={!!requestDetails?.categoryName}>
                    <div className="rd-info-item">
                        <Icon icon="nrk:category-active" className="rd-info-icon" />
                        <span>{requestDetails?.categoryName}</span>
                    </div>
                </CRRender>

                <CRRender isRender={!!requestDetails?.subCategoryName}>
                    <div className="rd-info-item">
                        <Icon icon="fa-solid:pump-medical" className="rd-info-icon" />
                        <span>{requestDetails?.subCategoryName}</span>
                    </div>
                </CRRender>

                <div className="rd-info-item">
                    <Icon icon="solar:calendar-date-bold" className="rd-info-icon" />
                    <span>{translate("Request date")}</span>
                    <span className="rd-info-date">
                        {FormateDate(requestDetails?.orderDate)}
                    </span>
                </div>
            </div>
            <div className="rd-tabs">
                <div className="rd-tab active">{translate("Available Hospital")}</div>
            </div>

        </>
    )
}

export default RequestInfo